import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import settingsPng from 'images/settings.png';
import squareFullPng from 'components/shared/checkbox/checkbox-square-full.png';
import SearchableDropDownPaginated from 'components/shared/dropdown/SearchableDropDownPaginated';
import TextareaAutosize from 'react-autosize-textarea';
import OutsideAlerter from 'components/shared/OutsideAlerter';
import moment from 'moment';

class MeetingItem extends Component {
  static propTypes = {
    itemKey: PropTypes.string.isRequired,
    item: PropTypes.shape({}).isRequired,
    meetingItemSettings: PropTypes.string,
    reviewMeeting: PropTypes.bool.isRequired,
    handleMeetingItemSettingsClick: PropTypes.func.isRequired,
    handleMeetingInfoMenuClick: PropTypes.func.isRequired,
    handleMeetingItemChange: PropTypes.func.isRequired,
    renderMenuForm: PropTypes.func.isRequired,
    loadContributors: PropTypes.func.isRequired,
  };

  render() {
    const { itemKey, item } = this.props;
    return (
      <tr>
        <td>
          {this.props.reviewMeeting || !item.code ? (
            ''
          ) : (
            <div
              className="meeting-item-settings"
              onClick={() => this.props.handleMeetingItemSettingsClick(itemKey)}
            >
              <img src={settingsPng} alt="settings" />
              {this.props.meetingItemSettings === 'menu' && (
                <OutsideAlerter
                  onClickOutside={() =>
                    this.props.handleMeetingItemSettingsClick(null)
                  }
                >
                  <div className="settings-menu">
                    {!item.newItem && (
                      <div
                        className="settings-menu-item"
                        onClick={(e) => {
                          this.props.handleMeetingInfoMenuClick(
                            e,
                            itemKey,
                            'new-info'
                          );
                        }}
                      >
                        Add New Information
                      </div>
                    )}
                    {!!item.resolved ? (
                      <div
                        className="settings-menu-item"
                        onClick={(e) => {
                          this.props.handleMeetingInfoMenuClick(
                            e,
                            itemKey,
                            'mark-unresolved'
                          );
                        }}
                      >
                        Mark as Unresolved
                      </div>
                    ) : (
                      <div
                        className="settings-menu-item"
                        onClick={(e) => {
                          this.props.handleMeetingInfoMenuClick(
                            e,
                            itemKey,
                            'mark-resolved'
                          );
                        }}
                      >
                        Mark as Resolved
                      </div>
                    )}
                    <div
                      className="settings-menu-item settings-menu-item-delete"
                      onClick={(e) => {
                        this.props.handleMeetingInfoMenuClick(
                          e,
                          itemKey,
                          'delete'
                        );
                      }}
                    >
                      Delete
                    </div>
                  </div>
                </OutsideAlerter>
              )}
              {this.props.meetingItemSettings === 'new-info' && (
                <OutsideAlerter
                  onClickOutside={() =>
                    this.props.handleMeetingItemSettingsClick(null)
                  }
                >
                  <div
                    className="settings-menu settings-menu-form"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    {this.props.renderMenuForm(itemKey, 'new-info')}
                  </div>
                </OutsideAlerter>
              )}
              {this.props.meetingItemSettings === 'mark-resolved' && (
                <OutsideAlerter
                  onClickOutside={() =>
                    this.props.handleMeetingItemSettingsClick(null)
                  }
                >
                  <div
                    className="settings-menu settings-menu-form"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    {this.props.renderMenuForm(itemKey, 'mark-resolved')}
                  </div>
                </OutsideAlerter>
              )}
            </div>
          )}
        </td>
        <td>
          <span className={!!item.newItem ? 'meeting-item-new' : ''}>
            {item.code || '-'}
          </span>
        </td>
        <td>
          {this.props.reviewMeeting ? (
            <span className={!!item.newItem ? 'meeting-item-new' : ''}>
              {item.info}
            </span>
          ) : (
            <TextareaAutosize
              className={!!item.newItem ? 'meeting-item-new' : ''}
              rows={1}
              placeholder="Discussion description goes here"
              defaultValue={item.info}
              onBlur={(e) =>
                this.props.handleMeetingItemChange(
                  itemKey,
                  'info',
                  e.target.value
                )
              }
            />
          )}
          {item.newInfo && (
            <span className="meeting-item-new">
              {' '}
              {moment(item.newInfoDate).format('M/D')} {item.newInfo}
              &nbsp;&nbsp;
            </span>
          )}
          {item.resolved && (
            <span className="resolved-label">
              {this.props.reviewMeeting && <span>&nbsp;&nbsp;</span>}
              <img src={squareFullPng} alt="settings" /> RESOLVED -{' '}
              {moment(item.resolvedDate).format('M/D')} {item.resolvedNote}
            </span>
          )}
        </td>
        <td>
          {item.contributorIds.map((contrib) => {
            const contribId = contrib[0];
            const contribLabel = contrib[1];
            return this.props.reviewMeeting ? (
              <div key={contribId} className="contributor-selected">
                {contribLabel}
              </div>
            ) : (
              <div
                key={contribId}
                className="contributor-selected"
                onClick={() => {
                  this.props.handleMeetingItemChange(
                    itemKey,
                    'contributorIds',
                    item.contributorIds.filter(
                      (contrib) => contrib[0] !== contribId
                    )
                  );
                }}
              >
                <span className="remove">X</span>
                <span>{contribLabel}</span>
              </div>
            );
          })}
          {!this.props.reviewMeeting && (
            <div className="contributor-add">
              <div className="add-row-plus">+</div>
              <SearchableDropDownPaginated
                loadOptions={this.props.loadContributors}
                onChange={(option) => {
                  if (
                    !item.contributorIds.find(
                      (contrib) => contrib[0] === option.value
                    )
                  ) {
                    this.props.handleMeetingItemChange(
                      itemKey,
                      'contributorIds',
                      item.contributorIds.concat([[option.value, option.label]])
                    );
                  }
                }}
                placeholder="Add Contributor"
              />
            </div>
          )}
        </td>
      </tr>
    );
  }
}

export default connect()(MeetingItem);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-meeting-minutes/MeetingItem.js